export default __webpack_public_path__ + "static/media/Cattura4.4d69bcdc.jpg";